<template>
  <div class="cart" @click.prevent="click_shadow($event.target.classList)">
    <div class="cart__container">
      <div class="cart__frame">
        <div class="cart__close">
          <a href="#" @click.prevent="close_cart">
            <img src="@/assets/icon/close_menu.png" alt="">
          </a>
        </div>
        <div class="cart__body">
          <div class="cart__emptyNote"
          v-if="cart.products.length === 0">
            <p>目前購物車內無任何品項</p>
            <a href="#" class="myBtn myBtn--primary">
              前往購物
            </a>
          </div>
          <ul class="cart__products">
            <li class="cart__products__li"
            v-for="(item, index) in cart.products"
            :key="index">
              <div class="cart__products__delete">
                <a href="#"
                @click.prevent="edit_quantity(0, index)">
                  <img src="@/assets/icon/remove_item.png" alt="">
                </a>
              </div>
              <div class="cart__products__img">
                <a href="#"
                @click="go_page(`/front/onlinestore/all/${item.id}`)">
                  <img :src="item.img" alt="">
                </a>
              </div>
              <div class="cart__products__info">
                <a href="#" class="cart__products__link"
                @click="go_page(`/front/onlinestore/all/${item.id}`)">
                  <p class="cart__products__title">
                  {{item.title}}
                  </p>
                  <p class="cart__products__id">
                    {{item.id}}
                  </p>
                  <div class="cart__products__price">
                    NT${{item.price}}
                  </div>
                </a>
                <div class="cart__products__quantity">
                  <span>數量:</span>
                  <b-form-spinbutton
                  @change="edit_quantity($event, index)"
                  v-model="item.quantity"
                  min="0"
                  max="100"></b-form-spinbutton>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="cart__sum">
          <p>金額小計: NT${{cart.sum}}</p>
        </div>
        <div class="cart__remark">
          <p>台灣本島地區全站商品免運配送</p>
        </div>
        <div class="cart__checkout"
        v-if="cart.products.length !== 0">
          <a href="#" class="myBtn myBtn--primary"
          @click='go_page("/front/checkout")'>
            前往結帳
          </a>
        </div>
        <ul class="cart__memberInfo"
        v-if="this.member.id !== ''">
          <li class="cart__memberInfo__item">
            <a href="#" @click="go_page('/front/member')">會員專區</a>
          </li>
          <li class="cart__memberInfo__item">
            <a href="#" @click="log_out">會員登出</a>
          </li>
        </ul>
        <div class="cart__notMember"
        v-if="this.member.id === ''">
          <a href="#" class="myBtn myBtn--secondary"
          @click="go_page('/front/login')">
            登入 / 加入會員
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['cart'],
  data() {
    return {
    };
  },
  computed: {
    member() {
      let result;
      this.$bus.$on('son_get_data', (data) => {
        result = data.member;
      });
      this.$bus.$emit('son_call_data');
      return result;
    },
  },
  methods: {
    go_page(route) {
      this.$router.push(route);
    },
    close_cart() {
      this.$bus.$emit('toggleCart', false);
    },
    click_shadow(classList) {
      const boolean = [...classList].includes('cart') || [...classList].includes('cart__container');
      if (boolean) {
        this.close_cart();
      }
    },
    edit_quantity(num, index) {
      if (num === 0) {
        this.cart.products.splice(index, 1);
      }
      this.$bus.$emit('editCart');
    },
    log_out() {
      this.$bus.$emit('log_out');
      this.$bus.$emit('toggleCart', false);
      this.go_page('/');
    },
  },
};
</script>
